import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { useHistory, useLocation } from 'react-router-dom';
import { apiUrl } from '../../constants';
import Swal from "sweetalert2";
const Activate = () => {
    const history = useHistory();
    let { search } = useLocation();
    const [guild,setGuild] = useState('')
    const [reset,setReset] = useState('')
    useEffect(async () => {
        const query = new URLSearchParams(search);
        const guild = query.get('Guid')
        const reset = query.get('Reset')
        setGuild(guild)
        setReset(reset)
        await axios({
            method: "get",
            url: `${apiUrl}/ActivateUser?Guid=${guild}`,
        }).then((res) => {
            Swal.fire("Activated user successful!<br>Please Log in to 'Komatsu sale support tool' again");
        })
    }, [])
    return (
        <>
            
        </>
    )
}

export default Activate